import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from 'src/app/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-manual-update-dialog',
  templateUrl: './manual-update-dialog.component.html',
  styleUrls: ['./manual-update-dialog.component.scss']
})

export class ManualUpdateDialogComponent implements OnInit {

  project: any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private router: Router,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.project = this.data.project;
  }

  cancel() {
    this.dialogRef.close();
  }

  manulUpdateProject() {
    const fd = new FormData();
    this.httpService.updateProject(fd, this.project.id).subscribe((res: any) => {
      if (res.code === 1) {
        this.toastrService.success('The project has been updated.');
      } else {
        this.toastrService.error('Failed to manual update this project.');
      }
      this.dialogRef.close(res);
    })
  }
}
